import * as React from "react";
const SvgArowMenu = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", height: "100%", viewBox: "16 13 8.5 15", fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 27L23.5 20.5L17 14", strokeWidth: 2 }));
export default SvgArowMenu;
